import "./App.css";
import { createPortal } from "react-dom";
import Cart from "./ecommerce/Cart";
import CheckoutAndPayment from "./ecommerce/CheckoutAndPayment";
import ThankYou from "./ecommerce/ThankYou";
import InvoiceThankyou from "./ecommerce/InvoiceThankyou";
import PrepaidTicketThankyou from "./ecommerce/PrepaidTicketThankyou";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

function App() {
    const [wrappers, setWrappers] = useState({
        cartWrapper: null,
        checkoutWrapper: null,
        thankYouWrapper: null,
        invoiceThankYouWrapper: null,
        PrepaidTicketThankyouWrapper: null
    });

    useEffect(() => {
        setWrappers({
            cartWrapper: document.getElementById("ecommerce-wrap"),
            checkoutWrapper: document.getElementById("checkout-and-payment-page"),
            thankYouWrapper: document.getElementById("thankyou"),
            invoiceThankYouWrapper: document.getElementById("invoice-thankyou"),
            PrepaidTicketThankyouWrapper: document.getElementById("prepaid-ticket-thankyou"),
        });
    }, []);

    const {
        cartWrapper,
        checkoutWrapper,
        thankYouWrapper,
        invoiceThankYouWrapper,
        PrepaidTicketThankyouWrapper
    } = wrappers;

    return (        
            <Router>
                <Routes>
                    {/* Direct routes */}
                    <Route path="/" element={
                        <>
                        {cartWrapper && createPortal(<Cart />, cartWrapper)}
                        {checkoutWrapper && createPortal(<CheckoutAndPayment />, checkoutWrapper)}
                        {thankYouWrapper && createPortal(<ThankYou />, thankYouWrapper)}
                        {invoiceThankYouWrapper && createPortal(<InvoiceThankyou />, invoiceThankYouWrapper)}
                        {PrepaidTicketThankyouWrapper && createPortal(<PrepaidTicketThankyou />, PrepaidTicketThankyouWrapper)}
                        </>
                        
                    }/>
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout_and_payment" element={<CheckoutAndPayment />} />
                    <Route path="/user/thankyou" element={<ThankYou />} />   
                    <Route path="/invoice-thankyou" element={<InvoiceThankyou />} />
                    <Route path="/prepaid-ticket-thankyou" element={<PrepaidTicketThankyou />} />
              
                </Routes>
            </Router>       
    );
}

export default App;